/* ------------------------------------*\
 * JS Main entry file
\* ------------------------------------*/
import { loadChunks, loadServiceWorker } from 'app_designholding/internal/initApp';
// Custom babel polyfill import to prevent multiple requires of the polyfill
import '@utilities/require-babel-polyfill.js';
// Import Stylesheet.
import '../scss/style.scss';
// Import Polyfills.
import '@polyfills';
// Import utilities.
import moduleInit from '@utilities/module-init';
// Import Singletons
import Events from '@utilities/events';
import '@utilities/drag';
// import '@utilities/google-maps';
import '@utilities/gtm';
import '@utilities/detect-touch';
import '@utilities/detect-keyboard-focus';
import '@utilities/focus-trap';
import '@utilities/init-js';
import '@utilities/in-view';
import '@utilities/scroll-to';
import '@utilities/history';
import '@utilities/page-css-variables';
// Import modules
import '@components/cookies';
import '@components/image';
import '@components/loader';
import VideoLoader from '@components/video/loader';

// Init service worker
loadServiceWorker();

// Async

moduleInit.async('[js-hook-background-component]', () =>
  import(/* webpackChunkName: "js/BackgroundScroll" */ './components/background-change'),
);

moduleInit.async('[js-hook-skip-link]', () => import(/* webpackChunkName: "js/SkipLink" */ '@utilities/skip-link'));
moduleInit.async('[js-hook-paged-navigation]', () => import(/* webpackChunkName: "js/PagedNavigation" */ '@components/paged-navigation'));

moduleInit.async('[js-hook-basic-slider]', () =>
  import(/* webpackChunkName: "js/BasicSlider" */ '@components/basic-slider'),
);

moduleInit.async('[js-hook-toggle]', () =>
  import(/* webpackChunkName: "js/Toggle" */ '@components/toggle'),
);
moduleInit.async('[js-hook-refinements]', () =>
  import(/* webpackChunkName: "js/Refinements" */ '@utilities/refinements'),
);
moduleInit.async('[js-hook-gtm]', () =>
  import(/* webpackChunkName: "js/GTMEvents" */ '@components/gtm-events'),
);
moduleInit.async('[js-hook-header]', () =>
  import(/* webpackChunkName: "js/Header" */ '@components/header'),
);
moduleInit.async('[js-hook-page]', () =>
  import(/* webpackChunkName: "js/Page" */ '@components/page'),
);
moduleInit.async('[js-hook-ajax-modal-button]', () =>
  import(/* webpackChunkName: "js/AjaxModalButton" */ '@components/ajax-modal-button'),
);
moduleInit.async('[js-hook-alert]', () =>
  import(/* webpackChunkName: "js/Alert" */ '@components/alert'),
);
moduleInit.async('[js-hook-accordion]', () =>
  import(/* webpackChunkName: "js/Accordion" */ '@components/accordion'),
);
moduleInit.async('[js-hook-add-to-cart]', () =>
  import(/* webpackChunkName: "js/AddToCart" */ '@components/add-to-cart'),
);
moduleInit.async('[js-hook-back-to-top]', () =>
  import(/* webpackChunkName: "js/BackToTop" */ '@components/back-to-top'),
);
moduleInit.async('[js-hook-background-light]', () =>
  import(/* webpackChunkName: "js/BackgroundgroundLight" */ '@components/background-light'),
);
moduleInit.async('[js-hook-contact-form]', () =>
  import(/* webpackChunkName: "js/ContactForm" */ '@components/contact-form'),
);
moduleInit.async('[js-hook-book-an-appointment-form]', () =>
  import(/* webpackChunkName: "js/BookAnAppointmentForm" */ '@components/book-an-appointment-form'),
);
moduleInit.async('[js-hook-contact-form-email]', () =>
  import(/* webpackChunkName: "js/ContactFormEmail" */ '@components/contact-form-email'),
);
moduleInit.async('[js-hook-chat]', () =>
  import(/* webpackChunkName: "js/Chat" */ '@components/chat'),
);
moduleInit.async('[js-hook-coupon-form]', () =>
  import(/* webpackChunkName: "js/CouponForm" */ '@components/coupon-form'),
);
moduleInit.async('[js-hook-fancy-list]', () =>
  import(/* webpackChunkName: "js/FancyList" */ '@components/fancy-list'),
);
moduleInit.async('[js-hook-lap]', () =>
  import(/* webpackChunkName: "js/LabelAsPlaceholder" */ '@components/form-elements/label-as-placeholder'),
);
moduleInit.async('[js-hook-mega-menu]', () =>
  import(/* webpackChunkName: "js/MegaMenu" */ '@components/mega-menu'),
);
moduleInit.async('[js-hook-input-sync]', () =>
  import(/* webpackChunkName: "js/InputSync" */ '@components/input-sync'),
);
moduleInit.async('[js-hook-mobile-navigation]', () =>
  import(/* webpackChunkName: "js/MobileNavigation" */ '@components/navigation'),
);
moduleInit.async('[js-hook-modal]', () =>
  import(/* webpackChunkName: "js/Modal" */ '@components/modal'),
);
moduleInit.async('[js-hook-ajax-modal]', () =>
  import(/* webpackChunkName: "js/AjaxModal" */ '@components/modal/ajax-modal'),
);
moduleInit.async('[js-hook-minicart-update]', () =>
  import(/* webpackChunkName: "js/Minicart" */ '@components/minicart'),
);
moduleInit.async('[js-hook-newsletter-form]', () =>
  import(/* webpackChunkName: "js/NewsletterForm" */ '@components/newsletter-form'),
);
moduleInit.async('[js-hook-product-attribute-size]', () =>
  import(/* webpackChunkName: "js/ProductAttributeSize" */ '@components/product-attribute/size'),
);
moduleInit.async('[js-hook-pagination]', () =>
  import(/* webpackChunkName: "js/Pagination" */ '@components/pagination'),
);
moduleInit.async('[js-hook-product-detail]', () =>
  import(/* webpackChunkName: "js/ProductDetail" */ '@components/product-detail'),
);
moduleInit.async('[js-hook-product-detail-hero]', () =>
  import(/* webpackChunkName: "js/ProductDetailHero" */ '@components/product-detail-hero'),
);
moduleInit.async('[js-hook-tab-nav-item]', () =>
  import(/* webpackChunkName: "js/TabNav" */ '@components/tab-nav'),
);
moduleInit.async('[js-hook-toggle-password]', () =>
  import(/* webpackChunkName: "js/TogglePassword" */ '@components/toggle-password'),
);
moduleInit.async('[js-hook-tooltip]', () =>
  import(/* webpackChunkName: "js/Tooltip" */ '@components/tooltip'),
);
moduleInit.async('[js-hook-search]', () =>
  import(/* webpackChunkName: "js/Search" */ '@components/search'),
);
moduleInit.async('[js-hook-set-cookie-on-click]', () =>
  import(/* webpackChunkName: "js/SetCookieOnClick" */ '@components/set-cookie-on-click'),
);
moduleInit.async('[js-hook-professional-trigger]', () =>
  import(/* webpackChunkName: "js/ProfessionalTrigger" */ '@components/professional-trigger'),
);
moduleInit.async('[js-hook-sort-select-box]', () =>
  import(/* webpackChunkName: "js/SortSelectBox" */ '@components/sort-select-box'),
);
moduleInit.async('[js-hook-scroll-gradient]', () =>
  import(/* webpackChunkName: "js/ScrollGradient" */ '@components/scroll-gradient'),
);
moduleInit.async('[js-hook-icon-list-carousel]', () =>
  import(/* webpackChunkName: "js/IconListCarousel" */ '@components/icon-list-carousel'),
);
moduleInit.async('[js-hook-navigation-bar]', () =>
  import(/* webpackChunkName: "js/NavigationBar" */ '@components/navigation-bar'),
);
moduleInit.async('[js-hook-scroll-into-view]', () =>
  import(/* webpackChunkName: "js/ScrollIntoView" */ '@components/scroll-into-view'),
);
moduleInit.async('[js-hook-remove-product]', () =>
  import(/* webpackChunkName: "js/RemoveProduct" */ '@components/remove-product'),
);
moduleInit.async('[js-hook-show-refinement-filters]', () =>
  import(/* webpackChunkName: "js/ShowRefinementFilters" */ '@components/show-refinement-filters'),
);
moduleInit.async('[js-hook-dropdown]', () =>
  import(/* webpackChunkName: "js/Dropdown" */ '@components/dropdown'),
);
moduleInit.async('[js-hook-refinement-filter]', () =>
  import(/* webpackChunkName: "js/RefinementFilter" */ '@components/refinement-filter'),
);
moduleInit.async('[js-hook-product-attribute]', () =>
  import(/* webpackChunkName: "js/ProductAttribute" */ '@components/product-attribute'),
);
moduleInit.async('[js-hook-product-range-slider]', () =>
  import(/* webpackChunkName: "js/ProductRangeSlider" */ '@components/product-range-slider'),
);
moduleInit.async('[js-hook-product-tile-button]', () =>
  import(/* webpackChunkName: "js/ProductTileButton" */ '@components/product-tile-button'),
);
moduleInit.async('[js-hook-quantity-selector]', () =>
  import(/* webpackChunkName: "js/QuantitySelector" */ '@components/quantity-selector'),
);
moduleInit.async('[js-hook-remove-coupon]', () =>
  import(/* webpackChunkName: "js/RemoveCoupon" */ '@components/remove-coupon'),
);
moduleInit.async('[js-hook-promotion-banner]', () =>
  import(/* webpackChunkName: "js/PromotionBanner" */ '@components/promotion-banner'),
);
moduleInit.async('[js-hook-shipping-form]', () =>
  import(/* webpackChunkName: "js/ShippingForm" */ '@components/shipping-form'),
);

moduleInit.async('[js-hook-form-fields-toggle]', () =>
  import(/* webpackChunkName: "js/FormFieldsToggle" */ '@components/form-fields-toggle'),
);

// #region ACCOUNT-SCRIPTS
moduleInit.async('[js-hook-address-form]', () =>
  import(/* webpackChunkName: "js/AddressForm" */ '@components/address-form'),
);
moduleInit.async('[js-hook-edit-email-form]', () =>
  import(/* webpackChunkName: "js/EditEmailForm" */ '@components/edit-email-form'),
);
moduleInit.async('[js-hook-edit-password-form]', () =>
  import(/* webpackChunkName: "js/EditPasswordForm" */ '@components/edit-password-form'),
);
moduleInit.async('[js-hook-edit-profile-form]', () =>
  import(/* webpackChunkName: "js/EditProfileForm" */ '@components/edit-profile-form'),
);
moduleInit.async('[js-hook-new-password-form]', () =>
  import(/* webpackChunkName: "js/NewPasswordForm" */ '@components/new-password-form'),
);
moduleInit.async('[js-hook-notification-form]', () =>
  import(/* webpackChunkName: "js/NotificationForm" */ '@components/notification-form'),
);
moduleInit.async('[js-hook-order-history-refinement]', () =>
  import(/* webpackChunkName: "js/OrderHistoryRefinement" */ '@components/order-history-refinement'),
);
moduleInit.async('[js-hook-register-form]', () =>
  import(/* webpackChunkName: "js/RegisterForm" */ '@components/register-form'),
);
moduleInit.async('[js-hook-create-account-form]', () =>
  import(/* webpackChunkName: "js/CreateAccountForm" */ '@components/create-account-form'),
);
moduleInit.async('[js-hook-remove-address]', () =>
  import(/* webpackChunkName: "js/RemoveAddress" */ '@components/remove-address'),
);
moduleInit.async('[js-hook-signin-form]', () =>
  import(/* webpackChunkName: "js/SigninForm" */ '@components/signin-form'),
);
moduleInit.async('[js-hook-reset-password-form]', () =>
  import(/* webpackChunkName: "js/ResetPasswordForm" */ '@components/reset-password-form'),
);
// #endregion ACCOUNT-SCRIPTS

moduleInit.async('[js-hook-custom-select-box]', () =>
  import(/* webpackChunkName: "js/CustomSelectBox" */ '@components/custom-select-box'),
);
moduleInit.async('[js-hook-high-res-image-gallery]', () =>
  import(/* webpackChunkName: "js/HighResImageGallery" */ '@components/high-res-image-gallery'),
);
moduleInit.async('[js-hook-image-zoom]', () =>
  import(/* webpackChunkName: "js/ImageZoom" */ '@components/image-zoom'),
);
moduleInit.async('[js-hook-image-modal]', () =>
  import(/* webpackChunkName: "js/ImageModal" */ '@components/image-modal'),
);
moduleInit.async('[js-hook-countdown]', () =>
  import(/* webpackChunkName: "js/Countdown" */ '@components/countdown'),
);
moduleInit.async('[js-hook-campaign-page-block]', () =>
  import(/* webpackChunkName: "js/CampaignPageBlock" */ '@components/campaign-page-block'),
);
moduleInit.async('[js-hook-shipping-methods]', () =>
  import(/* webpackChunkName: "js/ConditionalShippingMethods" */ '@components/conditional-shipping-methods'),
);
moduleInit.async('[js-hook-product-sample-modal-toggle]', () =>
  import(/* webpackChunkName: "js/ProductSampleModalToggle" */ '@components/product-sample-modal-toggle'),
);
moduleInit.async('[js-hook-product-sample-form]', () =>
  import(/* webpackChunkName: "js/ProductSampleForm" */ '@components/product-sample-form'),
);
moduleInit.async('[js-hook-shipping-methods]', () =>
  import(/* webpackChunkName: "js/ConditionalShippingMethods" */ '@components/conditional-shipping-methods'),
);
moduleInit.async('[js-hook-download-base64-pdf]', () =>
  import(/* webpackChunkName: "js/DownloadBase64Pdf" */ '@components/download-base64-pdf'),
);
moduleInit.async('[js-hook-site-popup]', () =>
  import(/* webpackChunkName: "js/SitePopup" */ '@components/site-popup'),
);
moduleInit.async('[js-hook-store-locator]', () =>
  import(/* webpackChunkName: "js/StoreLocator" */ './components/store-locator'),
);
moduleInit.async('[js-hook-store-locator-map]', () =>
  import(/* webpackChunkName: "js/StoreLocatorMap" */ './components/store-locator/store-locator-map'),
);
moduleInit.async('[js-hook-store-locator-results]', () =>
  import(/* webpackChunkName: "js/StoreLocatorResults" */ './components/store-locator/store-locator-results'),
);
moduleInit.async('[js-hook-store-locator-form]', () =>
  import(/* webpackChunkName: "js/StoreLocatorForm" */ './components/store-locator/store-locator-form'),
);
moduleInit.async('[js-hook-store-locator-filter]', () =>
  import(/* webpackChunkName: "js/RefinementFilter" */ '@components/store-locator-filter'),
);
moduleInit.async('[js-hook-accessibility]', () =>
  import(/* webpackChunkName: "js/AccessibilityManager" */ './utilities/accessibility/accessibility'),
);

VideoLoader.then(([Platforms, Video]) => {
  Video.default.registerPlatforms({
    native: Platforms.Native,
    youtube: Platforms.Youtube,
    vimeo: Platforms.Vimeo,
  });

  Events.$trigger('video::update');
}).catch(() => {});

/**
 * We use Einstein for product recommendations. This is loaded through async JS on the template.
 * Sometimes Einstein isn't fast enough so we have to init components afterwards.
 */
document.addEventListener(
  'einstein-ready',
  () => {
    // ADD ASYNC MODULES INITS HERE WHEN EINSTEIN IS READY
    moduleInit.async('[js-hook-basic-slider]', () =>
      import(/* webpackChunkName: "js/BasicSlider" */ '@components/basic-slider'),
    );

    Events.$trigger('events::dom-reinit');
  },
  {
    once: true,
  },
);

// load additional needed chunks
loadChunks();

// DH-4618 - Anchor link
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has("achid")) {
  const achidValue = urlParams.get("achid");
  const elementToScroll = document.getElementById(achidValue);
  if (elementToScroll) {
    Events.$trigger('scroll-to::scroll', {
      data: {
        target: elementToScroll,
        scrollElement: false // Optional, only needed when scrolling inside an element
      },
    })
  }
}
